import {
  useLiveAnnouncer,
  type UseLiveAnnouncer,
} from '@/shared/hooks/useLiveAnnouncer/useLiveAnnouncer';

export type UseStructuredAnnouncer = UseLiveAnnouncer;

/** The `uiKit` sentence a structured editor owes when it refuses an edit. */
const READ_ONLY_REFUSAL_KEY = 'structured.readOnlyRefused';

/**
 * What the structured-value family says out loud.
 *
 * One hook rather than a copy per control, for the reason the selection family
 * learned the hard way: the announcements ARE the behaviour, and the moment two
 * controls each own their copy of "this field is read-only" they have already
 * drifted into two different sentences.
 *
 * The mechanics moved to the shared `useLiveAnnouncer` in P10.2c, when `scalar/`
 * would otherwise have become the third identical copy of them. What stays here
 * is the family's own vocabulary — the `structured.*` refusal key — and the name
 * every editor in the family already imports.
 */
export function useStructuredAnnouncer(): UseStructuredAnnouncer {
  return useLiveAnnouncer(READ_ONLY_REFUSAL_KEY);
}
